module.exports = __webpack_public_path__ + "static/media/nz.b18d60a2.png";